import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesContent } from "../../constants";
import { UpdateAnnouncementRequestBody } from "./updateAnnouncement.types";

export const requestUpdateAnnouncement = async ({
  id,
  ...body
}: UpdateAnnouncementRequestBody): Promise<void> => {
  return await instance.patch(
    buildUrl(ApiRoutesContent.Announcement, id),
    body
  );
};
